
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { getLocalProject, unique } from "@/utils"; //类型
import _FormItem from "element-plus/lib/el-form-item";
import * as echarts from "echarts";
import {
  dispatchDeleteCODMReport,
  dispatchGetCODMReport,
  dispatchGetCODMReportList,
  dispatchSendCODMReport,
  dispatchUpdateComReport,
} from "@/store/performance/actions";
import { store } from "@/store";
import {
  readCODMReport,
  readCODMReportList,
} from "@/store/performance/getters";
import { readUserProfile } from "@/store/main/getters";
import {
  readMyProjects,
  readProjectDetail,
  readProjectUsers,
} from "@/store/project/getters";
import { ElMessage } from "element-plus";
import { dispatchGetProjectUsers } from "@/store/project/actions";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class MonoDump extends Vue {
  //声明属性
  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; // 当前页面的报告id
  // 测试结论
  public core_data: any[] = [];
  public link = "";
  public compare_link = "";
  public trend_data = {
    x_axis: ["1.0.30.13433"],
    scene_list: ["hall", "mp", "br"],
    mono: {
      hall: [145710],
      mp: [143410],
      br: [145410],
    },
    engine: {
      hall: [14510],
      mp: [145410],
      br: [145410],
    },
  };

  public memory_data = {
    hall: {
      engine: [
        {
          item: "all",
          size: 145410,
          baseline: 145411,
          ratio: "100.0%",
          change: -1,
          trend: "0.0%",
        },
      ],
      mono: [
        {
          item: "all",
          size: 147810,
          baseline: 145410,
          ratio: "100.0%",
          change: 2400,
          trend: "1.7%",
        },
      ],
    },
  };
  public memory_analysis = {
    hall: {
      type: "MonoBehaviour",
      engine: [
        {
          item: "all",
          size: 148810,
          number: 12354,
          base_size: 145410,
          base_number: 12355,
          ratio: "100.0%",
          change: 3400,
          trend: "2.3%",
        },
      ],
    },
  };
  public test_info = {
    cur_version: "1.0.30.13433",
    test_time: "2022/01/10",
    month: "2022.01",
    old_version: "1.0.29.13318",
    old_month: "2022.01",
    type: 0,
  };
  public com_risk = "低风险";
  public resBase64: any[] = []; // 存储趋势图base64编码及相关信息
  public loading = false;
  public async mounted() {
    // 图表
    this.loading = true;

    await dispatchGetProjectUsers(store, this.localProject);
    this.formMail.addressee = this.get_project_users();
    await dispatchGetCODMReportList(store, { project: this.localProject });
    if (this.$route.query.report_id) {
      this.report_id = Number(this.$route.query.report_id);
    } else {
      this.report_id = this.codm_reports[0] ? this.codm_reports[0]?.id : 0;
    }
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    let report_name = (readCODMReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0]?.cur_version;
    let report_time = (readCODMReportList(store) as any[])
      .filter((item: any) => item.id === this.report_id)[0]
      ?.test_time?.replace("/", "")
      ?.replace("/", "");
    this.formMail.title = (this.codm_reports.filter(
      (v: any) => v.id == this.report_id
    )[0] as any)?.report_name
      ? (this.codm_reports.filter((v: any) => v.id == this.report_id)[0] as any)
          ?.report_name
      : "CFM" +
        "\xa0" +
        "Dump内存测试报告-" +
        (this.codm_reports.filter((v: any) => v.id == this.report_id)[0] as any)
          ?.cur_version +
        "-" +
        (this.codm_reports.filter(
          (v: any) => v.id == this.report_id
        )[0] as any)?.test_time
          ?.replace("/", "")
          ?.replace("/", "");
    // "CODM" + "\xa0" + "Dump内存测试报告-" + report_name + "-" + report_time;
    if (this.report_id) {
      await dispatchGetCODMReport(store, {
        project: this.localProject,
        report_id: this.report_id,
      });
      this.set_report();
      this.get_risk();
    }

    this.project_info;
    await this.TrendChart("mono");
    await this.TrendChart("engine");
    this.loading = false;
  }
  // 切换报告
  public async change_report() {
    this.loading = true;
    this.resBase64 = [];
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    await dispatchGetCODMReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    let report_name = (readCODMReportList(store) as any[]).filter(
      (item: any) => item.id === this.report_id
    )[0].cur_version;
    let report_time = (readCODMReportList(store) as any[])
      .filter((item: any) => item.id === this.report_id)[0]
      .test_time.replace("/", "")
      .replace("/", "");
    this.formMail.title = (this.codm_reports.filter(
      (v: any) => v.id == this.report_id
    )[0] as any)?.report_name
      ? (this.codm_reports.filter((v: any) => v.id == this.report_id)[0] as any)
          ?.report_name
      : "CFM" +
        "\xa0" +
        "Dump内存测试报告-" +
        (this.codm_reports.filter((v: any) => v.id == this.report_id)[0] as any)
          .cur_version +
        "-" +
        (this.codm_reports.filter(
          (v: any) => v.id == this.report_id
        )[0] as any).test_time
          .replace("/", "")
          .replace("/", "");
    this.set_report();
    this.get_risk();
    await this.TrendChart("mono");
    await this.TrendChart("engine");
    this.loading = false;
  }
  public handleEdit() {
    this.dialogFormVisible1 = true;
    let reportData: any = this.codm_reports.filter(
      (v) => v.id == this.report_id
    )[0];
    if (reportData.report_name) {
      this.report_name = reportData.report_name;
    } else {
      this.report_name =
        "CFM" +
        "\xa0" +
        "Dump内存测试报告-" +
        reportData.cur_version +
        "-" +
        reportData.test_time.replace("/", "").replace("/", "");
    }
  }
  // 删除报告
  public async handleDelete() {
    this.loading = true;
    this.resBase64 = [];
    await dispatchDeleteCODMReport(store, {
      id: this.report_id,
      project: this.localProject,
    });
    this.report_id = this.codm_reports[0]?.id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    await dispatchGetCODMReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    this.set_report();
    this.get_risk();
    await this.TrendChart("mono");
    await this.TrendChart("engine");
    this.loading = false;
  }
  public get codm_reports() {
    return readCODMReportList(store);
  }
  public get_color(value: number | string, type: number) {
    if (value == "--") {
      return "";
    }
    if (typeof value === "number") {
      if (value < 0) {
        return "green";
      }
    } else if (typeof value === "string") {
      if (value.indexOf("New") !== -1) {
        return "pink";
      }
      if (value.indexOf("-") !== -1) {
        return "green";
      } else if (value.indexOf("%") !== -1) {
        const value_number = Number(value.split("%")[0]);
        if (value_number >= 8) {
          return "pink";
        } else if (value_number > 5) {
          return "pink2";
        } else {
          if (type === 1) {
            return "green";
          }
        }
      }
    }
  }
  public set_report() {
    const report = readCODMReport(store);
    this.test_info = report.test_info;
    this.memory_data = report.memory_data;
    this.memory_analysis = report.memory_analysis;
    this.trend_data = report.trend_data;
    this.core_data = report.core_data;
    this.link = report.link;
    this.compare_link = report.compare_link;
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  // 获取当前项目基本信息
  public get project_info() {
    return readProjectDetail(store);
  }
  public dialogFormVisible1 = false;
  public report_name = "";
  public get_trend_color(trend: string, control: number) {
    if (typeof trend !== "string") {
      return "";
    }
    let new_trend = Number(trend.split("%")[0]); // 绝对值
    let new_trend1 = trend.split("%")[1]; // ↑ or ↓
    if (new_trend < 5 || new_trend1 === "↓") {
      if (control === 1) {
        return "color: green;";
      } else {
        return "";
      }
    } else if (new_trend < 8) {
      return "color: orange;";
    } else {
      return "color: red;";
    }
  }
  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchUpdateComReport(store, {
      id: this.report_id,
      project: this.localProject,
      report_name: this.report_name,
    });
    await dispatchGetCODMReportList(store, { project: this.localProject });
  }
  public get_risk_color(com_risk: string) {
    if (com_risk === "高风险") {
      return "color: red;font-weight: bold;";
    } else if (com_risk === "中风险") {
      return "color: orange;font-weight: bold;";
    } else {
      return "color: green;font-weight: bold;";
    }
  }
  // 设置当前报告风险
  public get_risk() {
    let top: any[] = [];
    let mid: any[] = [];
    this.core_data.forEach((item) => {
      if (item.risk === "高风险") {
        top.push(1);
      } else if (item.risk === "中风险") {
        mid.push(1);
      }
    });
    if (top.length >= 1) {
      this.com_risk = "高风险";
    } else if (mid.length >= 1) {
      this.com_risk = "中风险";
    }
  }

  //图表
  public TrendChart(type: string) {
    let series_data: any[] = [];
    for (const [key, value] of Object.entries(this.trend_data[type])) {
      series_data.push({
        name: key,
        type: "line",
        // stack: "Total",
        data: value,
        smooth: false, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              show: true, // 显示数据
            },
          },
        },
      });
    }

    let trend_chart: any = document.getElementById(type);
    echarts.dispose(trend_chart);
    let month = this.test_info.month.split(".")[1];
    if (month[0] === "0") {
      month = month.slice(1);
    }
    let PerformanceLineChart = echarts.init(trend_chart);
    let option;
    option = {
      title: {
        text:
          type === "mono"
            ? "MONO托管对象总内存[MB]"
            : "NATIVE引擎对象总内存[MB]",
        x: "center",
        // backgroundColor: "green",
        textStyle: {
          fontSize: 16,
          // fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: this.trend_data.scene_list,
        x: "center",
        y: "bottom",
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "10%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.trend_data.x_axis,
      },
      yAxis: {
        type: "value",
        offset: 10,
        axisLabel: {
          formatter: "{value}",
        },
        scale: true,
        // max: function (value: any) {
        //   return Math.ceil(value.max * 1.10);
        // },
        min: function (value: any) {
          return Math.ceil(value.min * 0.9);
        },
        interval: 50, // 固定间隔为50
      },
      animation: false,
      series: series_data,
    };

    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.type = type;
    // res.filename = "report" + type + ".png";
    res.filename =
      "report" +
      type +
      "_project" +
      this.localProject +
      "_report" +
      this.$route.query.report_id +
      ".png";
    this.resBase64.push(res);
    return PerformanceLineChart;
  }

  // 头部
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  public async save_report() {
    let upload_data: any;
    upload_data = {
      // project: Number(this.$route.query.project),
      project: Number(this.localProject),
      report_id: Number(this.report_id),
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
    };
    dispatchSendCODMReport(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  public get_project_users() {
    const project_users = readProjectUsers(store);
    let user_list: any[] = [];
    project_users.forEach((item: any) => {
      if (item.is_project_admin) {
        user_list.push(item.user);
      }
    });
    return unique(user_list).join(";");
  }
}
